import { createAPI } from '@common'
export default {
  postRRTopics: config => createAPI('customEncryptApiName-1/0w20ss0upqjd', 'POST', config),
  getRRTopicsDetail: config => createAPI('customEncryptApiName-1/0w20ss0upqjd0efubjm', 'GET', config),
  postRRTopicsRemove: config => createAPI('customEncryptApiName-1/0w20ss0upqjd0sfnpwf', 'POST', config),
  postRRTopicsCopy: (config, vconfig) => createAPI('customEncryptApiName-1/OFXTQMBO;0w20ssupqjd0dpqz', 'POST', config, {hubForward: true, hub: 'e5/hub', ...vconfig}), // 选用
  postRRTopicsUse: config => createAPI('customEncryptApiName-1/0w20ss0upqjd0vtf', 'POST', config) // 记录选用
}
